import React from 'react';

const ViewModeToggle = ({ viewMode, setViewMode }) => (
  <div className="flex flex-row min-[480px]:flex-1 items-center justify-center sm:py-2">
    <div
      onClick={() => setViewMode(viewMode === 'list' ? 'grid' : 'list')}
      className="flex flex-row gap-1 items-center justify-center h-9 px-3 py-1 rounded-full hover:bg-amber-50/10 cursor-pointer"
    >
      <span className="material-symbols-outlined">
        {viewMode === 'list' ? 'view_list' : 'grid_on'}
      </span>
      <span className="max-[480px]:hidden">{viewMode === 'list' ? 'List View' : 'Grid View'}</span>
    </div>
  </div>
);

const SortOrderToggle = ({ sortOrder, setSortOrder }) => (
  <div className="flex flex-row min-[480px]:flex-1 items-center justify-center sm:py-2">
    <div
      onClick={() => setSortOrder(sortOrder === 'newest' ? 'oldest' : 'newest')}
      className="flex flex-row gap-1 items-center justify-center h-9 px-3 py-1 rounded-full hover:bg-amber-50/10 cursor-pointer"
    >
      <span className="material-symbols-outlined">swap_vert</span>
      <span className="max-[480px]:hidden">{sortOrder === 'newest' ? 'Recent First' : 'Oldest First'}</span>
    </div>
  </div>
);

export const HistoryControls = ({ viewMode, setViewMode, sortOrder, setSortOrder, ratingFilter, setRatingFilter }) => (
  <div className="flex flex-row items-center justify-between px-2 sm:py-0 py-2 uppercase pangram-sans-bold tracking-wider text-amber-50 select-none bg-neutral-800/90 backdrop-blur-sm sticky top-0 z-50">
    <ViewModeToggle viewMode={viewMode} setViewMode={setViewMode} />

    <div className="flex flex-row flex-1 items-center justify-center sm:py-2">
      <div className="relative flex flex-row gap-1 items-center justify-center h-9 px-3 py-1 rounded-full hover:bg-amber-50/10 cursor-pointer">
        <span className="pointer-events-none">
          {ratingFilter === null ? (
            <div className="flex gap-1 items-center">
              <span className="material-symbols-outlined">star</span>
              <span className="whitespace-nowrap">All Ratings</span>
            </div>
          ) :
          ratingFilter === 'did-not-listen' ? (
            <div className="flex gap-1 items-center">
              <span className="material-symbols-outlined">skip_next</span>
              <span className="whitespace-nowrap">Didn't Listen</span>
            </div>
          ) :
          ratingFilter === 0 ? (
            <div className="flex gap-1 items-center">
              <span className="material-symbols-outlined">more_horiz</span>
              <span className="whitespace-nowrap">Unrated</span>
            </div>
          ) :
              <div className="flex gap-0.5">
                {[...Array(ratingFilter)].map((_, i) => (
                  <span key={i} className="material-symbols-outlined">star</span>
                ))}
              </div>
          }
        </span>
        <select
          value={ratingFilter === null ? 'all' : ratingFilter}
          onChange={(e) => setRatingFilter(e.target.value === 'all' ? null : e.target.value === 'did-not-listen' ? 'did-not-listen' : Number(e.target.value))}
          className="absolute inset-0 opacity-0 w-full cursor-pointer"
        >
          <option value="all">All Ratings</option>
          <option value="1">One Star</option>
          <option value="2">Two Stars</option>
          <option value="3">Three Stars</option>
          <option value="4">Four Stars</option>
          <option value="5">Five Stars</option>
          <option value="0">Unrated</option>
          <option value="did-not-listen">Didn't Listen</option>
        </select>
      </div>
    </div>

    <SortOrderToggle sortOrder={sortOrder} setSortOrder={setSortOrder} />
  </div>
);

export default HistoryControls;